import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { DEMO_RETURNS, STORAGE_KEY } from "@/lib/returns";

const ReturnsContext = createContext(null);

function readStoredReturns() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : DEMO_RETURNS;
  } catch {
    return DEMO_RETURNS;
  }
}

export function ReturnsProvider({ children }) {
  const [returns, setReturns] = useState(readStoredReturns);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(returns));
  }, [returns]);

  const value = useMemo(
    () => ({
      returns,
      importReturns: (items) => setReturns((current) => [...items, ...current]),
      updateInspection: (orderId, inspection) => {
        setReturns((current) =>
          current.map((item) =>
            item.order_id === orderId ? { ...item, inspection } : item,
          ),
        );
      },
      updateReview: (orderId, review_status, flag_note = "") => {
        setReturns((current) =>
          current.map((item) => {
            if (item.order_id !== orderId || !item.inspection) {
              return item;
            }
            return {
              ...item,
              inspection: { ...item.inspection, review_status, flag_note },
            };
          }),
        );
      },
    }),
    [returns],
  );

  return <ReturnsContext.Provider value={value}>{children}</ReturnsContext.Provider>;
}

export function useReturns() {
  const context = useContext(ReturnsContext);

  if (!context) {
    throw new Error("useReturns must be used inside ReturnsProvider.");
  }

  return context;
}